import React from "react";
import { Message } from "primereact/message";
import styled from "styled-components";

export interface MessageProps {
  text: string;
}

const Info = styled(Message)`
  .p-message-icon,
  .p-inline-message-icon {
    color: blue !important;
  }
  .p-message-text,
  .p-inline-message-text {
    color: blue !important;
  }
`;

const Success = styled(Message)`
  .p-message-icon,
  .p-inline-message-icon {
    color: green !important;
  }
  .p-message-text,
  .p-inline-message-text {
    color: green !important;
  }
`;

const Warn = styled(Message)`
  .p-inline-message-warn {
    background: rgb(252, 248, 227) !important;
    border: #c09853 !important;
  }
  .p-message-icon,
  .p-inline-message-icon {
    color: #c09853 !important;
  }
  .p-message-text,
  .p-inline-message-text {
    color: #c09853 !important;
  }
`;

const Error = styled(Message)`
  .p-message-icon,
  .p-inline-message-icon {
    color: red !important;
  }
  .p-message-text,
  .p-inline-message-text {
    color: red !important;
  }
`;

export const MessageInfo: React.FC<MessageProps> = ({ text }) => (
  <Info severity="info" text={text}></Info>
);

export const MessageSuccess: React.FC<MessageProps> = ({ text }) => (
  <Success severity="success" text={text}></Success>
);

export const MessageWarn: React.FC<MessageProps> = ({ text }) => (
  <Warn severity="warn" text={text}></Warn>
);

export const MessageError: React.FC<MessageProps> = ({ text }) => (
  <Error severity="error" text={text}></Error>
);
